export enum SignatureModule {
  Partners = "partners",
  News = "news",
  Webinars = "webinars",
  Projects = "projects",
  Media = "media",
  Awards = "awards",
  Artists = "artists",
  Faqs = "faqs",
}
